import {fetch} from "utils/dataAccess";

export default function list(params) {
    return new Promise((resolve, reject) => {
        fetch(`/product?${params}&pagination=false&order[position]=asc`).then(response => {
            response.json().then(response => {
                resolve(response["hydra:member"])
            })
        }).catch(error => reject(error));
    });
}

export function get(id) {
    return new Promise((resolve, reject) => {
        fetch(`/products/${id}`).then(response => {
            response.json().then(response => {
                resolve(response)
            })
        }).catch(error => reject(error));
    });
}
